import { useTranslation } from 'react-i18next';
import { Ruler } from 'lucide-react';

import { ConfigToggleSetting } from './ConfigToggleSetting';

/**
 * Whether shoppers see their room's size, the quantity to buy and what it
 * costs — in the visualizer's forms, the design assistant and the chat.
 * Vendor config `shopperMeasurements`, on unless switched off.
 */
export const ShopperMeasurementsSetting = () => {
    const { t } = useTranslation();
    return (
        <ConfigToggleSetting
            field="shopperMeasurements"
            id="shopper-measurements-switch"
            icon={<Ruler />}
            label={t('PRODUCT_PRICING.SETTINGS.SHOPPER_MEASUREMENTS', 'Show room size, quantities and prices to shoppers')}
            description={t(
                'PRODUCT_PRICING.SETTINGS.SHOPPER_MEASUREMENTS_DESC',
                'Shoppers see how big their floor or wall is, how many boxes they need and what it costs, in the quote and next-step forms, the design assistant and the chat. They are not shown while browsing products.',
            )}
        />
    );
};
